/** Response header carrying the id of the guest user a request was matched to. */
export const guestUserLoginHint = "x-thalamos-guest-login-hint";
//# sourceMappingURL=httpHeaders.js.map